import { render, staticRenderFns } from "./TableID.vue?vue&type=template&id=36d6f81b&"
import script from "./TableID.vue?vue&type=script&lang=js&"
export * from "./TableID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports